import { Radio, Table } from 'antd';
import { useContext } from 'react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { MdCancel } from 'react-icons/md';
import { TiersConfigurationContext } from '../../../context/tiersConfigurationContext';

const RegionsTable = () => {
    const { elementSelected, regions, selectElement } = useContext(TiersConfigurationContext);

    const columns = [
        {
            title: '',
            dataIndex: '_id',
            key: '_id',
            width: 100,
            fixed: 'left' as 'left',
            render: (_id: any) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Radio
                        checked={!!(elementSelected && elementSelected._id === _id)}
                    />
                </div>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Active',
            dataIndex: 'isDeleted',
            key: 'isDeleted',
            render: (isDeleted: boolean) => (
                !isDeleted ? <AiFillCheckCircle color="green" size={25} /> : <MdCancel color="red" size={25} />
            ),
        },
    ];

    return (
        <div>
            <Table
                dataSource={regions.data}
                columns={columns}
                loading={regions.loading}
                rowClassName={(record) => (elementSelected && elementSelected._id === record._id ? 'ant-table-cell-row-hover' : '')}
                rowKey="userID"
                scroll={{ x: 800 }}
                onRow={(record) => ({
                    onClick: () => selectElement(record),
                })}
            />
        </div>
    );
};

export default RegionsTable;
